import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import dayjs from 'dayjs'
import { formatUIDate } from 'utils/helpers'
import {DownloadIcon} from "../../../../../icons";

export const toolbarActions = ({
                                 totalCount,
                                 exportFileCSV,
                                 isCSVExportLoading
                               }) => {
  let actions = []

  if (totalCount>0 && totalCount<=1000) {
    actions = [
      ...actions,
      {
        label: isCSVExportLoading ? 'Export in curs...' : 'Export CSV',
        icon: <DownloadIcon />,
        onClick: isCSVExportLoading ? () => {} : exportFileCSV
      }
    ]
  }

  return actions
}

export const columns = [
  {
    title: 'Cod cursǎ',
    field: 'transportCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Tip cursǎ',
    field: 'truckType',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Loc încǎrcare',
    field: 'flowType',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Data încǎrcare',
    field: 'expeditionDate',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => formatUIDate(row.expeditionDate)
  },
  {
    title: 'Numǎr masina_DEPOZIT',
    field: 'truckNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Nume Depozit',
    field: 'depositName',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Nume șofer',
    field: 'driverName',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Telefon șofer',
    field: 'driverPhone',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Denumire Hub',
    field: 'hubName',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Denumire Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Societate',
    field: 'parentSociety',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Categorie marfa',
    field: 'packageCategory',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Numǎr paleți',
    field: 'arrivedSupportsNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Număr paleți descărcati',
    field: 'supportsNumberReleased',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Dată prezentare - descărcare in HUB',
    field: 'inHubLoadingDateTime',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => formatUIDate(row.inHubLoadingDateTime)
  },
  {
    title: 'Oră prezentare in HUB',
    field: 'inHubPresentationHour',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Oră descărcare in HUB',
    field: 'inHubReleaseHour',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Dată încărcare marfă din HUB',
    field: 'inHubReleaseDateTime',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => formatUIDate(row.inHubReleaseDateTime)
  },
  {
    title: 'Oră încărcare marfă din HUB',
    field: 'inHubLoadingHour',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Număr masina_HUB',
    field: 'truckNumberHub',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Nume şofer',
    field: 'driverNameHub',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Număr paleți încărcati',
    field: 'loadedSupportsNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Dată descărcare marfă la magazin',
    field: 'inShopReleaseDate',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => formatUIDate(row.inShopReleaseDate)
  },
  {
    title: 'Oră descărcare marfă la magazin',
    field: 'inShopReleaseHour',
    align: 'left',
    type: 'string',
    width: '100px'
  }
]

export const drawerFilters = (
  shopOptions,
  depositOptions,
  hubOptions,
  societyOptions,
  locationOptions
) => [
  {
    name: 'shopCode',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Selectează magazin" options={shopOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Magazin'
  },
  {
    name: 'depositId',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Selectează depozit" options={depositOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Depozit'
  },
  {
    name: 'hubId',
    value: undefined,
    filter: <Autocomplete variant="outlined" label="Selectează HUB" options={hubOptions || []} />,
    type: 'autocomplete',
    label: 'Hub'
  },
  {
    name: 'transportCode',
    filter: <Input variant="outlined" label="Cod cursa" type="text" />,
    type: 'text',
    label: 'Cod cursa'
  },
  {
    name: 'parentSociety',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează societate"
        options={societyOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Societate'
  },
  {
    name: 'truckNumberDeposit',
    filter: <Input variant="outlined" label="Numar masina_DEPOZIT" type="text" />,
    type: 'text',
    label: 'Numar masina depozit'
  },
  {
    name: 'truckNumberHub',
    filter: <Input variant="outlined" label="Numar masina_HUB" type="text" />,
    type: 'text',
    label: 'Numar masina hub'
  },
  {
    name: 'typeFlow',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează loc de incarcare"
        options={locationOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Loc de incarcare'
  },

  {
    name: 'loadingDateStart',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data incarcare de la"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Data incarcare de la'
  },
  {
    name: 'loadingDateEnd',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data descarcare pana la"
        variant="outlined"
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
        value={dayjs()}
      />
    ),
    type: 'date',
    label: 'Data descarcare pana la'
  },
  {
    name: 'hubReleaseDate',
    value: '',
    filter: (
      <DatePicker
        label="Data descarcare hub"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Data descarcare hub'
  },
  {
    name: 'shopReleaseDate',
    value: '',
    filter: (
      <DatePicker
        label="Data descarcare magazin"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Data descarcare magazin'
  }
]
